import type { ExamType } from "../../../global-providers/rxdb-provider/collections/epocus-exam-worksheets";

export const EXAM_COLORS: Record<ExamType, string> = {
  efast: "#EF4444",
  cardiac: "#EC4899",
  lung: "#3B82F6",
  bladder: "#8B5CF6",
  renal: "#F59E0B",
  aorta: "#DC2626",
  pregnancy: "#DB2777",
};
